module.exports = __webpack_public_path__ + "static/taproom-bg-102129f1b6bcc2002cbdc100f9f4d9d5.jpg";